module.exports = __webpack_public_path__ + "fonts/u2f_70x70.d5897ef1a6e745da2959495574ff3929.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/icons/mfa/u2f_70x70.png
// module id = 794
// module chunks = 9